import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  savedLeadershipLanguageMeta: null,
};

const leadershipLanguageMetaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        savedLeadershipLanguageMeta: action.payload,
      };

    case actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default leadershipLanguageMetaReducer;
